document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.kiwi-sizing-modal span[aria-label="Close"]');
  
  if (closeBtn) {
    const modal = closeBtn.closest('.kiwi-sizing-modal');
    const video = modal?.querySelector('.ks-video video');

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }
});